import { memo } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { HeaderType } from '@utils/types';
import NO_IMAGE from '@assets/images/empty.png';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type PlaylistTableRowType = {
    header: HeaderType[];
    data: any;
    imgAspect: number;
};

const PlaylistTableRow = ({
    header = [],
    data,
    imgAspect
}: PlaylistTableRowType) => {
    return (
        <TableRow $noBorder $bold $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                <Image
                    src={`${data?.img}/${imgAspect > 1 ? 68 : 36}/${
                        imgAspect >= 1 ? 36 : 68
                    }`}
                    onError={(
                        e: React.SyntheticEvent<HTMLImageElement, Event>
                    ) => {
                        e.currentTarget.src = NO_IMAGE;
                    }}
                    alt="썸네일"
                    $width={imgAspect > 1 ? 68 : 36}
                    $height={imgAspect >= 1 ? 36 : 68}
                />
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.filename || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.type || '-'}
            </TableCell>
            <TableCell
                $minWidth={header[3].minWidth}
                $width={header[3].width}
                $alignRight
            >
                {data?.filesize || '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(PlaylistTableRow);

const Image = styled.img<{ $width?: number; $height?: number }>`
    display: block;
    width: ${({ $width }) => ($width ? $width : 68)}px;
    height: ${({ $height }) => ($height ? $height : 36)}px;
    border-radius: 2px;
    object-fit: contain;
`;
